import { IBlockableActivitySchedule } from '../../models/activities';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface IListBlockableActivitySchedulesServiceProps {
  activityId: string;
  blockedDate: string;
}

export const listBlockableActivitySchedulesService = async ({
  activityId,
  blockedDate,
}: IListBlockableActivitySchedulesServiceProps): Promise<
  IBlockableActivitySchedule[]
> => {
  const { data } = await jhsfBookingsApi.get(
    `/activities/${activityId}/session-blocks/available-schedules`,
    {
      params: { blockedDate },
    },
  );

  return data;
};
